<h2 class="!tw-mb-0" mat-dialog-title>
  {{ titleVariant() }} Profit & Loss Statement Item
</h2>

<mat-dialog-content>

  <form class="tw-pt-2" [formGroup]="formGroup">
    <mat-form-field class="tw-w-full">
      <mat-label>Year</mat-label>
      <input matInput [formControlName]="'year'" [type]="'number'" readonly disabled />
    </mat-form-field>

    <mat-form-field class="tw-w-full">
      <mat-label>Months</mat-label>
      <input matInput [formControlName]="'months'" [type]="'number'" />
    </mat-form-field>

    <mat-form-field class="tw-w-full">
      <mat-label>Revenue</mat-label>
      <input matInput [formControlName]="'revenue'" [type]="'number'" />
    </mat-form-field>

    <mat-form-field class="tw-w-full">
      <mat-label>Cost of Goods Sold</mat-label>
      <input matInput [formControlName]="'costOfGoodsSold'" [type]="'number'" />
    </mat-form-field>

    <mat-form-field class="tw-w-full">
      <mat-label>Net Income</mat-label>
      <input matInput [formControlName]="'netIncome'" [type]="'number'" />
    </mat-form-field>

    <mat-form-field class="tw-w-full">
      <mat-label>Compensation of Officers</mat-label>
      <input matInput [formControlName]="'compensationOfOfficers'" [type]="'number'" />
    </mat-form-field>

    <mat-form-field class="tw-w-full">
      <mat-label>Interest</mat-label>
      <input matInput [formControlName]="'businessInterest'" [type]="'number'" />
    </mat-form-field>

    <mat-form-field class="tw-w-full">
      <mat-label>Depreciation</mat-label>
      <input matInput [formControlName]="'depreciation'" [type]="'number'" />
    </mat-form-field>

    <mat-form-field class="tw-w-full">
      <mat-label>Amortization</mat-label>
      <input matInput [formControlName]="'amortization'" [type]="'number'" />
    </mat-form-field>

  </form>

</mat-dialog-content>

<mat-dialog-actions class="tw-p-2" [align]="'end'">
  <button mat-stroked-button mat-dialog-close>Cancel</button>
  <button mat-flat-button [color]="'primary'" (click)="save()">Save</button>
</mat-dialog-actions>
